module.exports = __webpack_public_path__ + "static/media/omega.aa6e33d3.png";